






import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import More from 'highcharts/highcharts-more';
import Sunburst from 'highcharts/modules/sunburst';
import Highcharts from 'highcharts';
import {colors} from '@/config';

More(Highcharts);
Sunburst(Highcharts);

@Component({components: {Chart}})
export default class YearWheel extends Vue {
  @Prop() slide: any;
  @Prop() dark!: boolean;
  @Prop({default: 1920}) containerWidth!: any;

  chartOptions: any = {};
  chartKey = 0;
  months = [{name: 'Januari', index: 0},
            {name: 'Februari', index: 1},
            {name: 'Mars', index: 2},
            {name: 'April', index: 3},
            {name: 'Maj', index: 4},
            {name: 'Juni', index: 5},
            {name: 'Juli', index: 6},
            {name: 'Augusti', index: 7},
            {name: 'September', index: 8},
            {name: 'Oktober', index: 9},
            {name: 'November', index: 10},
            {name: 'December', index: 11}];
  sortedMonths = this.months;

  @Watch('containerWidth', {immediate: false, deep: true})
  containerWidthChanged() {
    this.update();
  }

  @Watch('slide', {immediate: true, deep: true})
  slideChanged() {
    this.update();
  }

  sortMonths() {
    const startMonth = this.slide.startMonth || 0;
    const start = this.months.filter((m) => m.index >= startMonth);
    const end = this.months.filter((m) => m.index < startMonth);
    this.sortedMonths = start.concat(end);
  }

  update() {
    this.$nextTick(() => {
      const chart = this.$refs.chart as any;
      if (chart && chart.chart) {
        chart.chart.reflow();
      }
    });

    this.chartKey++;
    this.sortMonths();

    const texts = this.slide.texts || {};
    const currentMonth = new Date().getMonth();

    const data = [{
      id: '0.0',
      parent: '',
      name: ' ',
      value: 12,
      disableHover: true,
    }];

    for (let i = 0; i < 12; i++) {
      const month = this.sortedMonths[i];
      const m = {
        id: `1.${month.index}`,
        parent: '0.0',
        name: month.name.substring(0, 3),
        value: 3,
        color: colors.Primary,
        disableHover: true,
      };
      if (month.index === currentMonth) {
        m.color = colors.Secondary;
      }
      data.push(m);
    }

    for (const key in texts) {
      if (Object.prototype.hasOwnProperty.call(texts, key)) {
        if (texts[key] === '') {
          continue;
        }
        data.push({
          id: key,
          parent: key.split('.').slice(0, 2).join('.'),
          name: texts[key],
          value: 1,
          disableHover: false,
        });
      }
    }

    this.chartOptions = {
      chart: {
        height: '80%',
        margin: [0, 0, 0, 0],
        backgroundColor: colors.Light,
      },

      credits: {
        enabled: false,
      },
      title: {
        text: ' ',
      },

      series: [{
        type: 'sunburst',
        data,
        name: 'Root',
        animation: false,
        allowDrillToNode: false,
        borderWidth: this.transformPx(1),
        borderColor: colors.DarkGrey,
        padding: 0,
        dataLabels: {
          format: '{point.name}',
          connectorPadding: 0,
          padding: 0,
          distance: 0,
          style: {
            fontSize: this.transformPx(25),
            fontWeight: 'normal',
            textOutline: 'none',
            color: colors.White,
          },
        },
        levels: [{
          level: 1,
          levelIsConstant: true,
          levelSize: {
            unit: 'weight',
            value: 1,
          },
          color: 'transparent',
        }, {
          level: 2,
          color: colors.Primary,
          colorByPoint: true,
          levelIsConstant: true,
          levelSize: {
            unit: 'weight',
            value: 1,
          },
        },
          {
            level: 3,
            levelSize: {
              unit: 'weight',
              value: 4,
            },
            color: colors.LightGrey,
            dataLabels: {
              style: {fontWeight: 'bold', color: colors.Black},
            },
          }],
        point: {
          events: {
            mouseOver() {
              if ((this as any).disableHover) {
                (this as any).setState('');
              }
            },
          },
        },
        states: {
          hover: {
            color: colors.Tertiary,
            borderColor: colors.Black,
            brightness: 0,
            style: {color: 'red'},
          },
        },
      }],

      tooltip: {
        enabled: false,
      },

    };
  }

  transformPx(value: any) {
    if ( value * (this.containerWidth / 1920) < 1 ) {
      return 1;
    }
    return value * (this.containerWidth / 1920);
  }

}
